import { Injectable, ɵConsole } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { TenantSubscriptionInformationModel } from "../models/tenant.subscription.information.model";
import { AddressModel } from "../models/address.model";
import { TenantModel } from "../models/tenant.model";
import { SubscriptionModel } from "../models/subscription.model";
import { ResultModel } from "../models/result.model";
import { map } from 'rxjs/operators';
import { query } from "@angular/animations";

@Injectable({
  providedIn: "root",
})
export class TenantService extends BaseService {

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<TenantModel[]>>(this.getApiUrl("tenants/list"), formData);
  }


  create(tenant: TenantModel, address: AddressModel) {
    if (this.getQueryString(address) == "") {
      return this.httpClient.post<ResultModel>(this.getApiUrl("tenants"), tenant);
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl("tenants?" + this.getQueryString(address)) , tenant);
    }
  }

  update(tenant: TenantModel, address?: AddressModel, subscription?: SubscriptionModel) {

    var addressQuery =  this.getQueryString(address);
    var subscriptionQuery = this.getQueryString(subscription);
    var queryString = "";

    queryString += addressQuery == "" ? "" : addressQuery;

    queryString += queryString == "" 
                    ? (subscriptionQuery == "" ? "" : "&" + subscriptionQuery)
                    : (subscriptionQuery == "" ? "" : "&" + subscriptionQuery);

    if (queryString != "")
      queryString = "?" + queryString; 

    return this.httpClient.put(this.getApiUrl("tenants" + queryString), tenant);

    /*
    if (this.getQueryString(address) == "") {
      return this.httpClient.put(this.getApiUrl("tenants"), tenant);
    }
    else {
      return this.httpClient.put(this.getApiUrl("tenants?address=" + this.getQueryString(address) + '&subscription=' + this.getQueryString(subscription)), tenant);
    }
    */
  }

  get(id: string) {
    return this.httpClient.get<{ Tenant: TenantModel, Address: AddressModel, Subscription: SubscriptionModel, TenantSubscriptionInformation: TenantSubscriptionInformationModel }>(this.getApiUrl("tenants/" + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl("tenants/" + id));
  }

  suspend(id: string) {
    var formData = new FormData;
    return this.httpClient.put<ResultModel>(this.getApiUrl(`tenants/${id}/suspend`), formData)
  }

}
